/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'notices': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M192 768h-64C57.6 768 0 710.4 0 640V448c0-70.4 57.6-128 128-128h64L467.2 44.8c25.6-25.6 64-25.6 89.6 0C569.6 57.6 576 70.4 576 89.6v864c0 38.4-25.6 64-64 64-12.8 0-32-6.4-38.4-12.8L192 768zm531.2-6.4c-19.2 6.4-38.4 6.4-44.8-12.8-6.4-12.8-6.4-32 12.8-44.8C761.6 665.6 800 588.8 800 512c0-83.2-44.8-153.6-115.2-192-12.8-6.4-19.2-25.6-12.8-44.8 12.8-19.2 32-19.2 44.8-12.8C806.4 313.6 864 409.6 864 512s-57.6 198.4-140.8 249.6zm128 89.6c-12.8 12.8-32 6.4-44.8-6.4s-6.4-32 6.4-44.8C902.4 736 960 627.2 960 518.4c0-115.2-57.6-217.6-147.2-288-12.8-12.8-19.2-32-6.4-44.8s32-19.2 44.8-6.4C960 256 1024 377.6 1024 512s-64 256-172.8 339.2z"/>'
  }
})
